import { proxyBE, proxyApiMnemo, mnemoService } from "./common";

export const newsletterService = {
  validatereCaptcha(gToken) {
    return proxyBE.get(`newsletter/validate-recaptcha/${gToken}`);
  },

  subscribe(payload) {
    return proxyBE.post("newsletter/subscribe", payload);
  },

  getSubscribersStats() {
    return proxyBE.get("admin/newsletter/subscribers-stats");
  },

  exportSubscribers(payload) {
    return proxyBE.get(`admin/newsletter/export-subscribers/${JSON.stringify(payload)}`, { responseType: "blob" });
  },

  cancelSubscription(payload) {
    return proxyBE.put("admin/newsletter/cancel-subscription", payload);
  },

  getNewsletterEmails() {
    return proxyBE.get("admin/newsletter-email/list");
  },

  getNewsletterEmail(id) {
    return proxyBE.get(`admin/newsletter-email/${id}`);
  },

  createEmailJob(payload) {
    return proxyBE.post("admin/newsletter-email", payload);
  },

  updateEmailJob(payload) {
    return proxyBE.put("admin/newsletter-email", payload);
  },

  startEmailJob(id) {
    return proxyBE.put(`admin/newsletter-email/start/${id}`);
  },

  suspendEmailJob(id) {
    return proxyBE.put(`admin/newsletter-email/suspend/${id}`);
  },

  exportEmails(id) {
    return proxyBE.get(`admin/newsletter-email/export/${id}`, { responseType: "blob" });
  },

  subscribeNewsletterTo(data) {
    const payload = mnemoService.buildPayload("subscribe", "email", data.payload.email);
    return proxyApiMnemo.post("newsletter", payload);
  },
};
